// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"cf58910c","434":"ec61df4b","987":"a9b25a71"}[chunkId] + ".chunk.css";
};